var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16.5978 8.39922 17 9.14539 17 10C17 10.3582 16.9293 10.6974 16.8032 11M17 4C18.7934 5.19765 20 7.43616 20 10C20 11.0747 19.788 12.0923 19.4096 13C19.2634 13.3508 19.0923 13.6851 18.899 14M13 12V13.6917C13 15.8499 13 16.9291 12.7332 17.3924C12.2061 18.3079 11.0579 18.6556 10.1114 18.1862C9.63246 17.9487 9.03386 17.0508 7.83667 15.255C7.60011 14.9002 7.48183 14.7227 7.33865 14.5806C7.06197 14.306 6.71106 14.1181 6.32906 14.0403C6.13138 14 5.91814 14 5.49167 14H4.2C3.07989 14 2.51984 14 2.09202 13.782C1.71569 13.5903 1.40973 13.2843 1.21799 12.908C1 12.4802 1 11.9201 1 10.8V9.2C1 8.07989 1 7.51984 1.21799 7.09202C1.40973 6.71569 1.71569 6.40973 2.09202 6.21799C2.51984 6 3.0796 6 4.19911 6C4.45189 6 4.71894 6 5 6H5.49167C5.91814 6 6.13138 6 6.32906 5.95971C6.49306 5.92628 6.65133 5.87259 6.80046 5.80046M13 12L6.80046 5.80046M13 12L20 19M2 1L6.80046 5.80046M8.67267 3.5C9.34331 2.51894 9.75964 1.98824 10.1114 1.81378C11.0579 1.34443 12.2061 1.69209 12.7332 2.60759C13 3.07091 13 4.15005 13 6.30832V8",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeDown);
export default __webpack_public_path__ + "static/media/volume-down.5c48182960f4b1fc49771bb339c8a637.svg";
export { ForwardRef as ReactComponent };